import React from "react";
import classes from "./tools.module.scss";
import { Button, Card, Col, Row, Typography } from "antd";
import { NavLink, useNavigate } from "react-router-dom";
import { ShoppingOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

const Tools = () => {
  const navigate = useNavigate();
const cardData = [
    {
      title: 'Objective Guidance',
      description: 'Get tailored insights based on your goals and data.',
      route: '/home/objective-analysis',
    },
    {
      title: 'Decision Comparison',
      description: 'Compare multiple options with clear pros and cons.',
      route: '/home/decision-comparison',
    },
    {
      title: 'Collaboration',
      description: 'users',
      route: '/home/collaboration',
    },
    {
      title: 'More Coming',
      description: 'New features and decision tools are on the way!',
      route: '',
    },
  ]; 

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className={classes.header}>
          <Title level={4} style={{ marginTop: 0 }}>
            Tools
          </Title>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Welcome to the Tools page. Here you can find various tools to assist
            you.
          </Text>
        </div>
        <Button className="radar-Guide-step-12">
          <ShoppingOutlined />
          <NavLink to={'/business-tool-marketplace'}>MarketPlace</NavLink>
        </Button>
      </div>
      <Row gutter={[16, 16]}>
      {cardData.map((card, index) => (
        <Col xs={24} sm={12} md={8} key={index}>
          <Card
            title={card.title}
            bordered={false}
            style={{ borderRadius: 10, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', cursor: 'pointer' }}
            onClick={() => card?.route && navigate(card.route)}
          >
            {card.description}
          </Card>
        </Col>
      ))}
    </Row>
    </div>
  );
};

export default Tools;
